<template>
  <v-content>
    <!-- スタンプ系 -->
    <div class="px-3 pb-4">
      <v-row align="center" justify="center" no-gutters class="mb-3" :style="{width: baseWidth + 'px', position: basePosition, 'z-index': baseZindex}">
        <v-col cols="2" class="d-flex align-end"><img :src="menu.title_icon_url" style="width:30px;height:30px"></v-col>
        <v-col cols="5" style="position: relative; left: -15px;">
          <span style="font: bold 13px/22px 'Roboto';">STAMP CARD</span>
        </v-col>

        <v-col cols="5" class="text-right" style="font: bold 12px/16px 'Roboto';">
          <v-btn rounded elevation="2" x-small width="120px" height="30px" color="#FFFFFF" class="maincolor"
          @click.stop="$emit('set', menu.button_url, menu.feature_id, menu.screen_id, menu.transition_type, menu.top_type, menu.cassette_id, menu.transition_info, menu.title)">
            すべて表示
          </v-btn>
        </v-col>
      </v-row>
      <v-card :width="parentWidth" :height="parentHeight" class="elevation-6">
        <v-card :width="childWidth" :height="childHeight" class="elevation-6" v-if="stamp.data">
          <v-img :src="stamp.data[0].image_path" height="194px"></v-img>
          <p class="mx-4 mt-5 mb-0" style="font: bold 14px/20px 'Roboto';">
            {{stamp.data[0].title}}
          </p>
          <div class="mx-4 mt-2" style="font: normal 9px/13px 'Roboto';">
            <p class="ma-0">有効期限：{{stamp.data[0].expiration_date}}</p>
            <p class="ma-0">対象店舗：{{stamp.data[0].shop_names}}</p>
          </div>
          <v-row align="start" justify="center" no-gutters class="mt-4">
            <v-btn rounded dark :width="stampWidth" class="maincolor" style="font: bold 14px/24px 'Roboto';" @click.stop="toStampAuth(stamp.data[0].id, stamp.data[0].auth_type, stamp.data[0].shop_id)">
              STAMP GET
            </v-btn>
            <v-btn v-if="stamp.comp_ticket_flg" rounded outlined disabled x-small style="font: bold 12px/20px 'Roboto';" class="mt-5">
              獲得済みチケットを見る
            </v-btn>
          </v-row>
        </v-card>
        <v-card :width="parentWidth" :height="parentHeight" class="elevation-6" v-if="!stamp.data">
          <v-img src="@/assets/topc3.png" class="text-center">
            <v-row align="center" justify="center" :style="{height: noDataHeight + 'px', font: noDataFont, color: noDataColor}">
              現在利用できる<br>スタンプカードはありません
            </v-row>
          </v-img>
        </v-card>
        <div class="text-center mt-4" v-if="stamp.data > 1">
          <p class="mb-0 maincolor" style="font: bold 11px/16px 'Roboto';">現在ご利用可能なスタンプカードが{{stamp.data.length}}枚あります</p>
          <a class="maincolor" style="font: bold 9px/16px 'Roboto';" @click.stop="$emit('set', menu.button_url, menu.feature_id, menu.screen_id, menu.transition_type, menu.top_type, menu.cassette_id, menu.transition_info, menu.title)">すべて表示</a>
        </div>
      </v-card>
    </div>

  </v-content>
</template>

<script>
export default {
  props: ['stamp', 'menu'],
  // NEW_DEV-2057 cyber start
  data () {
    return {
      init:[],
      baseWidth: 295,
      basePosition: 'relative',
      baseZindex: 3,
      parentHeight: 463,
      parentWidth: 295,
      childHeight: 403,
      childWidth: 295,
      stampWidth: 200,
      noDataHeight: 463,
      noDataFont: "normal 14px/22px 'Roboto'",
      noDataColor: '#9D9D9D',
    }
  },
  created() {
    var baseWidth = 295
    var parentHeight = 463
    var parentWidth = 295
    var childHeight = 413
    var childWidth = 295
    var stampWidth = 200
    var noDataHeight = 463

    var wh = window.innerHeight
    const isIPad = /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document

    if(wh > 590 &&isIPad ){
      var raito = wh / 548
      this.baseWidth = baseWidth * raito
      this.parentHeight = parentHeight * raito
      this.parentWidth = parentWidth * raito
      this.childHeight = childHeight * raito
      this.childWidth = childWidth * raito
      this.stampWidth = stampWidth * raito
      this.noDataHeight = noDataHeight * raito
    }
  },
  methods: {
    async toStampAuth(id, auth_type, shop_id){
      try {
        // 多重処理防止
        if (this.loading) return
        this.loading = true

        this.init = this.storageGet("*");
        var tap_req = {
            sid: this.init.sid,
            service_cd: this.init.service_cd,
            device_uid: this.init.device_uid,
            device_id: this.init.device_id,
            os: this.init.os,
            key: this.init.key,
            top_type: this.menu.top_type,
            cassette_id: this.menu.cassette_id,
            transition_type: this.menu.transition_type,
            transition_info: this.menu.transition_info
          };

        var tap_res = await this.apiCall("/user/tap", tap_req, "post");
        if (!tap_res) { return false }
        // NEW_DEV-2057 cyber end

        var destination = null
        var screenID = null
        switch (auth_type) {
          case 1:
            destination = 'stampAuthCodeActivity'
            screenID = 'stamp_auth_code'
            break;
          case 2:
            destination = 'stampAuthQrActivity'
            screenID = 'stamp_auth_qr'
            break;
          case 3:
            destination = 'stampAuthBeaconActivity'
            screenID = 'stamp_auth_beacon'
            break;
          case 4:
            destination = 'stampAuthWifiActivity'
            screenID = 'stamp_auth_wifi'
            break;
          default:
            // 20210203 NEW_DEV-1407 cyber start
            destination = 'stampAuthCodeActivity'
            screenID = 'stamp_auth_code'
            break;
            // 20210203 NEW_DEV-1407 cyber start
        }
        var tonative_req = {
          'destination': destination,
          'feature_id': 'stamp',
          'screen_id': screenID,
          'transition_type': 3,
          'stamp_id': id,
          'shop_id': shop_id,
        };

        if (!(this.screenTransition(tonative_req))) {
          this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
        }

      } catch {
        this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3)
      } finally {
        // 正常, 異常に関わらず処理完了時はスピナー解除
        this.loading = false
      }
    },
  },
}
</script>
